export class FaltaMedicaDTO {

    id: number = 0;

    idMedico: number = 0;

    nomeMedico: string = '';

    dataFalta: Date = new Date();

    horaFalta: string = '';

    faltaDiaInteiro: boolean = false;

    faltaPeriodoManha: boolean = false;

    faltaPeriodoTarde: boolean = false;

    motivoFalta: string = '';

    horaFaltaNumber: number = 0;

    tipoFaltaFormatado: string = '';

    constructor() {
    }

    tipoDeFaltaFormatada(): string {

        let tipoFaltaFormatado = '';

        if (this.faltaDiaInteiro) {
            tipoFaltaFormatado = "DIA INTEIRO";
        } else if (this.faltaPeriodoManha) {
            tipoFaltaFormatado = "PERÍODO MANHÃ";
        } else if (this.faltaPeriodoTarde) {
            tipoFaltaFormatado = "PERÍODO TARDE";
        } else {
            tipoFaltaFormatado = "HORÁRIO ESPECÍFICO";
        }

        this.tipoFaltaFormatado = tipoFaltaFormatado;
        
        return tipoFaltaFormatado;
    }

}
